import * as React from 'react';
import { Divider } from '@chakra-ui/react';

export const MenuSeparator = () => <Divider orientation="vertical" h={6} my="auto" mx={2} />;
